import { Component, HostListener, OnInit, signal, input, inject, Renderer2 } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FirmaDettaglioComponent } from '../../private/firma/firma-dettaglio/firma-dettaglio.component';
import { DettaglioPraticaComponent } from '../../../app/private/dettaglio-pratica/dettaglio-pratica.component';

@Component({
	selector: 'app-firma-dettaglio-switcher',
	standalone: true,
	imports: [CommonModule, FirmaDettaglioComponent, DettaglioPraticaComponent],
	template: `
		@if (isMobile()) {
			<app-dettaglio-pratica [idTransaction]="idTransaction()" [isPublic]="isPublic()" />
		} @else {
			<app-firma-dettaglio [idTransaction]="idTransaction()" [isPublic]="isPublic()" />
		}
	`,
})
export class FirmaDettaglioSwitcherComponent implements OnInit {
	renderer = inject(Renderer2);

	idTransaction = input<string>();
	isPublic = input<boolean>(false);

	isMobile = signal(false);

	@HostListener('window:resize')
	onResize() {
		this.checkWidth();
	}

	ngOnInit() {
		this.checkWidth();
	}

	private checkWidth() {
		const isMob = window.innerWidth <= 768;
		this.isMobile.set(isMob);

		if (isMob) {
			this.renderer.addClass(document.body, 'platform-app');
			this.renderer.removeClass(document.body, 'platform-web');
		} else {
			this.renderer.addClass(document.body, 'platform-web');
			this.renderer.removeClass(document.body, 'platform-app');
		}
	}
}
